import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ProductButton from '../../../products/components/product_button/ProductButton';
import { productsActions } from '../../actions';
import { productsObjectsSelector } from '../../../products/selectors/products';

function AddToBag(props) {
  const {
    product, buttonColor = 'blue', addToBagRequest, products,
  } = props;

  const loading = products.find((item) => item.id === product.id)?.loading;

  const {
    waitlistSubscribable, subscribed, available, redirectionEnabled, redirectText, addToBagText,
    redirectLink, limitation, url, price, discount, id, sku, name, variant, variantId,
    showAddToBag, image,
  } = product;

  const addToBagClickHandler = (eventId) => {
    addToBagRequest({ id, variantId, eventId });
  };

  return (
    <ProductButton
      waitlistSubscribable={waitlistSubscribable}
      subscribed={subscribed}
      available={available}
      showAddToBag={showAddToBag}
      redirectionEnabled={redirectionEnabled}
      redirectText={redirectText}
      redirectLink={redirectLink}
      limitation={limitation}
      loading={loading}
      productUrl={url}
      addToBagClickHandler={addToBagClickHandler}
      price={parseFloat(price)}
      discount={parseFloat(discount) || 0}
      productId={id}
      sku={sku}
      name={name}
      variant={variant}
      buttonColor={buttonColor}
      addToBagText={addToBagText}
      image={image}
    />
  );
}

AddToBag.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    sku: PropTypes.string,
    discount: PropTypes.string,
    price: PropTypes.string,
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    waitlistSubscribable: PropTypes.bool,
    subscribed: PropTypes.bool,
    available: PropTypes.bool.isRequired,
    redirectionEnabled: PropTypes.bool.isRequired,
    redirectText: PropTypes.string.isRequired,
    redirectLink: PropTypes.string.isRequired,
    variant: PropTypes.string,
    limitation: PropTypes.number,
    estimatedShipDate: PropTypes.string,
    variantId: PropTypes.number,
    showAddToBag: PropTypes.bool,
    addToBagText: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  buttonColor: PropTypes.oneOf([
    'black', 'white', 'blue', 'transparent-blue', 'yellow', 'green', 'transparent-green',
  ]),
  addToBagRequest: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number }),
  ).isRequired,
};

const mapStateToProps = (state) => ({
  products: productsObjectsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  addToBagRequest: (id) => dispatch(productsActions.addToBagRequest(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddToBag);
